export default {"src":"/_next/static/media/fr-flag.42d96a0f.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};